import React from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../../hooks/useSettings';

const Footer: React.FC = () => {
  const { settings } = useSettings();

  return (
    <footer className="bg-white border-t w-full">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-600">
            &copy; {new Date().getFullYear()} {settings?.title || 'İnanöz Hukuk'}. Tüm hakları saklıdır.
          </p>
          <div className="flex gap-6">
            <Link to="/gizlilik-politikasi" className="text-sm text-gray-600 hover:text-gray-900">
              Gizlilik Politikası
            </Link>
            <Link to="/kullanim-kosullari" className="text-sm text-gray-600 hover:text-gray-900">
              Kullanım Koşulları
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;